import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full relative py-16 md:py-24 overflow-hidden" aria-labelledby="cta-heading">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20digital%20background%20with%20warm%20orange%20and%20cream%20gradient%2C%20soft%20flowing%20geometric%20waves%2C%20minimalist%20clean%20design%2C%20smooth%20gradients%2C%20light%20ethereal%20atmosphere%2C%20no%20text%20or%20logos%2C%20professional%20corporate%20style%2C%20subtle%20particle%20effects&width=1920&height=600&seq=cta-bg-91cc&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 id="cta-heading" className="text-2xl md:text-3xl font-bold font-heading text-white mb-4">
          准备开始使用 91.cc 了吗？
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8 max-w-lg mx-auto leading-relaxed">
          立即访问 91.cc 官方平台，体验完整功能与服务。如有疑问，请查看我们的使用指南或联系客服。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://91.cc"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-3 text-base font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            访问 91.cc 官方平台
            <i className="ri-arrow-right-up-line ml-2 text-lg"></i>
          </a>
          <Link
            to="/about"
            className="inline-flex items-center px-8 py-3 text-base font-medium rounded-full border border-white/40 text-white hover:bg-white/15 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
            <i className="ri-arrow-right-line ml-2 text-lg"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}